import React, { useEffect, useCallback, useState} from 'react';
import {setSelectedPianoRollSteps} from 'actions/index.js';
import {setCirklonMode} from 'actions/index.js';
import {connect} from 'react-redux';

const CirklonModeButton = ({
    mode,
    cirklonMode,
    setCirklonMode,
    setSelectedSteps
}) => { 
    let className = "cirklon-mode-btn";
    if (mode === cirklonMode) {
        className += " selected";
    }

    const onClick = useCallback((e) => {
        setCirklonMode(mode === cirklonMode ? undefined : mode);
    }, [mode, cirklonMode]);
    return (
        <div onClick={onClick} className={className}>
          {mode}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      cirklonMode: state.cirklon.cirklonMode[props.track.id]
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
      setCirklonMode: (x) => dispatch(setCirklonMode(props.track.id, x)),
      setSelectedSteps: (steps) =>
          dispatch(setSelectedPianoRollSteps(steps))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CirklonModeButton);
